import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';

// dashboard routing
const DashboardDefault = Loadable(lazy(() => import('views/dashboard/Default')));
const DashboardDefaultAdmin = Loadable(lazy(() => import('views/dashboard/Default/AdminDashboard')));
const DashboardCustomer = Loadable(lazy(() => import('views/dashboard/Default/CustomerFile')));
const DashboardUser = Loadable(lazy(() => import('views/dashboard/Default/UserFile')));

// utilities routing
const UtilsTypography = Loadable(lazy(() => import('views/utilities/Typography')));
const UtilsCalendar = Loadable(lazy(() => import('views/utilities/Calendar')));
const UtilsShadow = Loadable(lazy(() => import('views/utilities/Shadow')));
const UtilsRecommendedServices = Loadable(lazy(() => import('views/utilities/RecommendedServices')));
const UtilsImportantPhones = Loadable(lazy(() => import('views/utilities/ImportantPhones')));
const UtilsMaterialIcons = Loadable(lazy(() => import('views/utilities/MaterialIcons')));
const UtilsTablerIcons = Loadable(lazy(() => import('views/utilities/TablerIcons')));

// sample page routing
const SamplePage = Loadable(lazy(() => import('views/sample-page')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
    path: '/',
    element: <MainLayout />,
    children: [
        {
            path: '/',
            element: <DashboardDefault />
        },
        {
            path: 'dashboard',
            children: [
                {
                    path: 'default',
                    element: <DashboardDefault />
                },
                {
                    path: 'homify-admin',
                    element: <DashboardDefaultAdmin />
                },
                {
                    path: 'create',
                    element: <DashboardCustomer />
                },
                {
                    path: 'create-user',
                    element: <DashboardUser />
                }
            ]
        },
        {
            path: 'utils',
            children: [
                {
                    path: 'util-typography',
                    element: <UtilsTypography />
                }
            ]
        },
        {
            path: 'utils',
            children: [
                {
                    path: 'util-typography',
                    element: <UtilsTypography />
                }
            ]
        },
        {
            path: 'utils',
            children: [
                {
                    path: 'util-calendar',
                    element: <UtilsCalendar />
                }
            ]
        },
        {
            path: 'utils',
            children: [
                {
                    path: 'util-shadow',
                    element: <UtilsShadow />
                },
                {
                    path: 'util-recommended-services',
                    element: <UtilsRecommendedServices />
                },
                {
                    path: 'util-important-phones',
                    element: <UtilsImportantPhones />
                }
            ]
        },
        {
            path: 'icons',
            children: [
                {
                    path: 'tabler-icons',
                    element: <UtilsTablerIcons />
                }
            ]
        },
        {
            path: 'icons',
            children: [
                {
                    path: 'material-icons',
                    element: <UtilsMaterialIcons />
                }
            ]
        },
        {
            path: 'sample-page',
            element: <SamplePage />
        }
    ]
};

export default MainRoutes;
